import { OPEN_AUTHORIZATION_STATUSES } from 'common/Status/authorizationConstants';

export default function isAuthEditRequested(serviceAuthorization) {
  return serviceAuthorization?.lineage?.some((auth) => (
    OPEN_AUTHORIZATION_STATUSES.some((openState) => auth.state === openState))) ?? false;
}
